// Impultienda checkout funnel "Mate Collection" (store argentine-mate-experience).
export const CHECKOUT_URL = "https://argentine-mate-experience.impultienda.ar/o/mate-collection";
// Meta pixel "Mate Experience" (business saber digital).
export const META_PIXEL_ID = "1635420285031033";
